const recentInteractionAddAllTeamMembers = (loadedItems) => (dispatch) => {
  dispatch({
    type: 'RECENT_INTERACTIONS_ADD_ALL_TEAM_MEMBERS',
    loadedItems,
  });
};

export default recentInteractionAddAllTeamMembers;
